import { useEffect, useRef, useState } from "react";

/** @deprecated We are phasing out `cc-ui` */
export const useConditionalTooltip = <T extends HTMLElement>(condition?: boolean) => {
  const [shouldShow, setShouldShow] = useState(false);
  const ref = useRef<T | null>(null);

  useEffect(() => {
    if (ref.current) {
      if (condition === undefined) {
        setShouldShow(ref.current.scrollWidth > ref.current.clientWidth);
        return;
      }

      setShouldShow(condition);
    }
  }, [condition, ref]);

  return {
    disableListeners: {
      disableFocusListener: !shouldShow,
      disableHoverListener: !shouldShow,
      disableTouchListener: !shouldShow,
    },
    ref,
    shouldShow,
  };
};
